export default __webpack_public_path__ + "static/media/0083.72530190.jpg";